<template>
  <div class="ict-container">
    <div class="ict-container-banner">
    <Header></Header>
    <div class="container-banner-text1">政企数字化</div>
    <div class="container-banner-text2">全方位多元化直播营销</div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import Header from "@/componets/header/Header"
export default {
  components: {
    Header,
  }
}
</script>

<style lang="less" scoped>
/deep/ .header-container {
  position: fixed !important;
  top: 0;
  z-index: 10000;
}
.ict-container-banner {
  width: 19.2rem;
  height: 7.8rem;
  overflow: hidden;
  background-image: url("../../../assets/images/online.png");
  background-size: 19.2rem 7.8rem;
}
//banner图的文字样式
.container-banner-text1 {
  font-size: 0.66rem;
  text-align: left;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 0.98rem;
  color: #333333;
  margin-top: 2.67rem;
  margin-left: 3.6rem;
  margin-bottom: 0.05rem;
}
.container-banner-text2 {
  font-size: 0.66rem;
  text-align: left;
  font-family: Source Han Sans CN;
  font-weight: 300;
  line-height: 0.98rem;
  color: #666666;
  margin-left: 3.6rem;
}
</style>
